import React, { FC, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Placeholder } from 'semantic-ui-react';
import './counter-box.less';

export interface CounterBoxMobileProps extends WithTranslation {
  loading: boolean;
  count: number;
  title: string;
  color: string;
  clickable?: boolean;
  onClick?: () => void;
  className?: string;
  id?: string;
  selected?: boolean;
  small?: boolean;
}

const CounterBoxMobile: FC<CounterBoxMobileProps> = props => {
  const [hovered, setHovered] = useState(false);

  if (props.loading) {
    return (
      <Placeholder className={`admin-counter-placeholder ${props.className || ''}`} id={props.id}>
        <Placeholder.Header>
          <Placeholder.Line className="counter-placeholder" />
          <Placeholder.Line className="title-placeholder" />
        </Placeholder.Header>
      </Placeholder>
    );
  }

  const style: React.CSSProperties = {};

  if (hovered || props.selected) {
    style.backgroundColor = props.color;
    style.color = 'white';
    style.cursor = 'pointer';
  } else {
    style.color = props.color;
    style.backgroundColor = 'white';
    style.cursor = props.clickable ? 'pointer' : 'default';
  }

  const onMouseOver = () => {
    if (props.clickable) setHovered(true);
  };

  const onMouseOut = () => {
    if (props.clickable) setHovered(false);
  };

  const onClick = () => {
    if (props.clickable && props.onClick) {
      props.onClick();
    }
  };

  const counterFontSize = props.small ? '1.80rem' : '2rem';
  const titleFontSize = props.small ? '1rem' : '1rem';
  const padding = props.small ? '0.2rem 0.75rem' : '1rem 1.5rem';
  const minHeight = props.small ? 48 : 72;

  return (
    <div
      className={`admin-counter-box flex flex-col items-center justify-center rounded-md shadow border border-gray-200 transition-colors text-center w-full ${props.className ??
        ''}`}
      style={{ ...style, padding, minHeight }}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      id={props.id}
      tabIndex={props.clickable ? 0 : undefined}
      role={props.clickable ? 'button' : undefined}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: counterFontSize,
          lineHeight: 1,
          marginBottom: 8,
          width: '100%',
          color: style.color
        }}
      >
        {props.count}
      </div>
      <div
        style={{
          fontWeight: 500,
          fontSize: titleFontSize,
          width: '100%',
          color: style.color
        }}
      >
        {props.title}
      </div>
    </div>
  );
};

export default withTranslation()(CounterBoxMobile);
